import { render, staticRenderFns } from "./pic&video.vue?vue&type=template&id=7c39744b&scoped=true&"
import script from "./pic&video.vue?vue&type=script&lang=js&"
export * from "./pic&video.vue?vue&type=script&lang=js&"
import style0 from "./pic&video.vue?vue&type=style&index=0&id=7c39744b&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c39744b",
  null
  
)

export default component.exports